import React from "react";
import { Navigate } from "react-router-dom";

const RedirectIfLoggedIn = ({ userData, children }) => {
    const getRedirectByCategory = (category) => {
        if (category === "S1" || category === "C1") return "/sales";
        if (category === "P1") return "/production";
        return "/";
    };

    if (userData.length > 0) {
        const category = userData[0]?.CATEGORY;
        const redirectPath = getRedirectByCategory(category);
        return <Navigate to={redirectPath} replace />;
    }
    return children;
};

export default RedirectIfLoggedIn;
